import { ERatingActions, RatingActions } from "@edp-store/actions/rating.actions";
import { initialRatingState, IRatingState } from "@edp-store/state/rating.state";

export function ratingReducers(state = initialRatingState, action: RatingActions): IRatingState {
    switch (action.type) {
        case ERatingActions.SaveRatingStatus: {
            return {
                ...state,
                rating: action.payload,
            };
        }
        default: {
            return state;
        }
    }
}
